import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { GlobalService } from '../services/global.service';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);
  private globalService = inject(GlobalService);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      map((customer) => {
        if (!customer) {
          return true;
        }
        this.globalService.navigateToHome();
        return false;
      }),
      catchError(() => {
        return of(true);
      })
    );
  }
}
